import { AirService, Cabinet, Carriage, CFrame, CropMarks, DragChain, Floor, Table, XAxis } from './kit'
import { Stipple } from './padParts'
import { face } from './projection'
import { Head, HeadRods } from './screenHead'
import { HangerBodies, HangerRods, MeshPattern, Panel, Pins, PrintTable, ScreenBack, ScreenFront } from './screenParts'

/* ==========================================================================
   The screen-printing film: one pass. The flood bar coats the stencil with
   the screen up, the screen drops to its off-contact gap, the squeegee
   presses the mesh onto the panel and strokes back across it (the tracking
   shot: the blade's face, the bead rolling ahead, the mesh V behind, the
   openings left with a residue), the screen lifts and the two printed knob
   scales stand white on the black panel.
   ========================================================================== */

const REG_LEADER = 'M1083 526L1104 505H1420'

function ScreenDefs({ id }) {
  return (
    <defs>
      <Stipple id={id} />
      <MeshPattern id={id} />
    </defs>
  )
}

/* The payoff: crops fly in around the right scale, the leader draws out. */
function Register() {
  return (
    <g className="pp-register">
      <CropMarks transform={face(998, 562)} scale={1.4} />
      <g className="pp-reg-leader">
        <path className="l-knock" d={REG_LEADER} />
        <path className="l-signal" d={REG_LEADER} />
      </g>
      <circle className="f-live pp-reg-dot" cx="1083" cy="526" r="3.5" />
    </g>
  )
}

/** The machine, back to front. */
function Machine({ id }) {
  return (
    <>
      <Floor />
      <Cabinet />
      <Table />
      <HangerRods />
      <HangerBodies />
      <CFrame />
      <AirService />
      <DragChain />
      <XAxis />
      <PrintTable />
      <Pins at="back" />
      <Panel id={id} />
      <Pins at="side" />
      <ScreenBack id={id} />
      <HeadRods />
      <Carriage />
      <Head />
      <ScreenFront />
      <Register />
    </>
  )
}

export function ScreenStage({ id }) {
  return (
    <>
      <ScreenDefs id={id} />
      <g className="pp-cam">
        <Machine id={id} />
      </g>
    </>
  )
}
